const LEGACY_KEY_V0 = 'bizfirst.flow-observer.panel.v0';
const LEGACY_KEY_V1 = 'bizfirst.flow-observer.panel.v1';

export function migrateIfNeeded(): void {
  if (localStorage.getItem(LEGACY_KEY_V0) !== null) {
    localStorage.removeItem(LEGACY_KEY_V0);
  }
  // v1 → v2: v2 defaults differ (HIL overlay tabs added); drop stale v1 state rather than migrate
  if (localStorage.getItem(LEGACY_KEY_V1) !== null) {
    localStorage.removeItem(LEGACY_KEY_V1);
  }
}
